import { RootState } from 'redux/schemas';
import { Institution, OrgMentorRoleAlias } from 'redux/schemas/models/institution';
import { createSelector } from 'reselect';

/* eslint-disable import/prefer-default-export */

export const getCurrentInstitution = (state: RootState): Institution => {
  if (!state.app.currentInstitutionId) {
    return null;
  }

  return state.models.institutions[state.app.currentInstitutionId];
};

export const getRoleAliases = (state: RootState): OrgMentorRoleAlias => {
  if (!state.app.currentInstitutionId) {
    return null;
  }
  return state.models.institutions[state.app.currentInstitutionId].roleAliases;
};

export const getBrand = createSelector(
  [getCurrentInstitution],
  ({ name, logo, logoSize, brandColor, brandBarFontColor }) => ({
    name,
    logo,
    logoSize,
    brandColor,
    brandBarFontColor: brandBarFontColor?.toUpperCase() || '#000',
  }),
);

export const getDiscoveryEnabled = createSelector(
  [getCurrentInstitution],
  ({ discoveryEnabled }) => discoveryEnabled,
);
